import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row } from "react-bootstrap";
import CardAbout from "./CardAbout";
import aboutData from "../data/aboutData";

// https://app.moqups.com/i2eQE1fOXK/view/page/a8eb22ca9

const About = () => {
  const getListOfList = () => {
    var content = [];
    var tempContent = [];

    for (var i = 0; i < aboutData.length; i++) {
      if (i % 3 === 0) {
        content.push(tempContent);
        tempContent = [];
      }
      tempContent.push(aboutData[i]);
    }

    if (tempContent.length) content.push(tempContent);

    return content;
  };

  return (
    <div id="about" className="hash">
      <div className="text-center bg-light p-5">
        {/* <h2>What we offer?</h2> */}
        <a href="#pricing" class="btn-shine text-dark p-2">What</a>
        <a href="#pricing" class="btn-shine text-dark p-2">we</a>
        <a href="#pricing" class="btn-shine text-dark p-0">Offer?</a>
      </div>

      <Container className="mt-5">
        {getListOfList().map((row) => (
          <Row className="text-center">
            {row.map((col) => (
              <CardAbout key={col.id} {...col} />
            ))}
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default About;
